export const API_CONSTANTS = {
  SUCCESS_CODE: 0,
  RECORDS_NOT_FOUND_CODE: 2,
  DEFAULT_TIMEZONE: "UTC",
  DEFAULT_SORT_NUMBER: 1,
  DEFAULT_SORT_ORDER_ASC: "ASC",
  DEFAULT_SORT_ORDER_DESC: "DESC",
};

export const statusList = {
  New: {
    status: "Pending",
    color: "#FFC107",
  },
  Approved: {
    status: "Approved",
    color: "#4CAF50",
  },
  Rejected: {
    status: "Rejected",
    color: "#DC3545",
  },
  Hold: {
    status: "Hold",
    color: "#546E7A",
  },
  ALL_PAY_REQUESTS: {
    status: "All Pay Requests",
    color: "#00A1E4",
  },
};
